// AI Generated Component
import { Component, Input } from '@angular/core';
import { IntercomService } from '@client/app/modules/chat/intercom/services/intercom.service';

@Component({
    selector: 'captext',
    standalone: false,
    template: `
        <div class="row">
            <div class="col-48 px-0 alert alert-warning text-center">
                @let formattedDomainItemCount = domainItemCount | monNumber;
                @let formattedMaxPageCount = maxPageCount | monNumber;
                <span *ngIf="scanDocuments"
                      translate
                      [translate-args]="{domainTitle: getDomainTitle(), domainItemCount: formattedDomainItemCount, maxPageCount: formattedMaxPageCount}">
                    We have registered that [[domainTitle]] has been scanned for a total of
                    [[domainItemCount]] pages and documents and your plan's limit is
                    [[maxPageCount]] pages and documents.
                </span>
                <span *ngIf="!scanDocuments"
                      translate
                      [translate-args]="{domainTitle: getDomainTitle(), domainItemCount: formattedDomainItemCount, maxPageCount: maxPageCount}">
                    We have registered that [[domainTitle]] has been scanned for a total of
                    [[domainItemCount]] pages and your plan's limit is
                    [[maxPageCount]] pages.
                </span>

                <span
                        translate
                        class="cursor-pointer text-link"
                        (click)="contact()">
                    Click here to contact Acquia Web Governance sales department to increase your maximum page count.
                </span>
            </div>
        </div>
    `,
})
export class CaptextComponent {
    @Input() domainTitle: any;
    @Input() domainItemCount: any;
    @Input() maxPageCount: any;
    @Input() scanDocuments: any;

    constructor (private intercomService: IntercomService) {}

    contact (): void {
        this.intercomService.addMsg('I would like to chat to someone about increasing my page limit');
    }

    getDomainTitle (): string {
        return '<span class="text-bold">' + this.domainTitle + '</span>';
    }
}
